export default {
  SET_DRAFTS(state, { drafts, projectId }) {
    state.drafts = drafts
    state.projectId = projectId
  },

  SET_DRAFTS_LOADING(state, isLoading) {
    state.draftsLoading = isLoading
  },

  SET_ACTIVE_DRAFT(state, { draft, projectId }) {
    state.activeDraft = draft
    state.projectId = projectId

    if (draft?.draft?.id) {
      const draftExists = state.drafts.some(item => item.id === draft.draft.id)
      state.drafts = draftExists
        ? state.drafts.map(item => (item.id === draft.draft.id ? draft.draft : item))
        : [...state.drafts, draft.draft]
    }
  },

  SET_DRAFT_LOADING(state, isLoading) {
    state.draftLoading = isLoading
  },

  SET_DRAFT_CREATING(state, isCreating) {
    state.draftCreating = isCreating
  },

  SET_DRAFT_MUTATING(state, isMutating) {
    state.draftMutating = isMutating
  },

  SET_DRAFT_DELETING(state, draftId) {
    state.draftDeletingId = draftId
  },

  REMOVE_DRAFT(state, draftId) {
    state.drafts = state.drafts.filter(draft => draft.id !== draftId)

    if (state.activeDraft?.draft?.id === draftId) {
      state.activeDraft = null
    }
  },

  SET_PROJECT_CONTEXT(state, projectId) {
    state.drafts = []
    state.projectId = projectId
    state.activeDraft = null
    state.draftsLoading = false
    state.draftLoading = false
    state.draftCreating = false
    state.draftMutating = false
    state.draftDeletingId = null
  }
}
